// extracted by mini-css-extract-plugin
module.exports = {"productCard":"ProductCard_productCard__1WIIN","image":"ProductCard_image__3o18D"};